import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  screenWidth: 1800,
  isMobile: false,
  isTouchScreen: false,
};

const screenSlice = createSlice({
  name: "screen",
  initialState,
  reducers: {
    setScreenWidth(state, action) {
      state.screenWidth = action.payload;
    },
    setIsMobile(state, action) {
      state.isMobile = action.payload;
    },
    setIsTouchScreen(state, action) {
      state.isTouchScreen = action.payload;
    },
  },
});

export const { setScreenWidth, setIsMobile, setIsTouchScreen } =
  screenSlice.actions;
export default screenSlice.reducer;
